"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormRules = void 0;
var FormRuleType_1 = require("./FormRuleType");
var FormRuleType_2 = require("./FormRuleType");
Object.defineProperty(exports, "FormRuleType", { enumerable: true, get: function () { return FormRuleType_2.FormRuleType; } });
var FormRules = /** @class */ (function () {
    function FormRules(name) {
        this.rules = [];
        this.name = name;
    }
    FormRules.withName = function (fieldLocalName) {
        return new FormRules(fieldLocalName);
    };
    FormRules.formatMessageByLimit = function (min, max, type, unit) {
        if (type === void 0) { type = ''; }
        if (unit === void 0) { unit = ''; }
        var existMin = typeof min === 'number';
        var existMax = typeof max === 'number';
        var message;
        if (existMax && existMin) {
            message = ":name\u5FC5\u987B\u662F" + type + "\uFF0C\u4E14" + unit + "\u5728:min\u5230:max\u4E4B\u95F4";
        }
        else if (existMax) {
            message = ":name\u5FC5\u987B\u662F" + type + "\uFF0C\u4E14" + unit + "\u5C0F\u4E8E\u7B49\u4E8E:max";
        }
        else if (existMin) {
            message = ":name\u662F\u5FC5\u987B\u662F" + type + "\uFF0C\u4E14" + unit + "\u5927\u4E8E\u7B49\u4E8E:min";
        }
        else {
            message = ":name\u5FC5\u987B\u662F" + type;
        }
        if (existMin) {
            message = message.replace(':min', String(min));
        }
        if (existMax) {
            message = message.replace(':max', String(max));
        }
        return message;
    };
    // 验证时转换数字类型（但是并不影响最终值）
    FormRules.transformNumber = function (value) {
        if (typeof value === 'number') {
            return value;
        }
        return typeof value === 'string' && value.length ? Number(value) : void 0;
    };
    FormRules.prototype.isRequired = function (onlyWhiteSpaceIsError) {
        if (onlyWhiteSpaceIsError === void 0) { onlyWhiteSpaceIsError = true; }
        var lastRule = this.rules[this.rules.length - 1];
        if (!lastRule) {
            this.string();
            lastRule = this.rules[this.rules.length - 1];
        }
        lastRule.required = true;
        lastRule.whitespace = onlyWhiteSpaceIsError;
        return this;
    };
    FormRules.prototype.append = function (obj) {
        var cloneObj = __assign({}, obj);
        if (typeof cloneObj.message === 'string') {
            cloneObj.message = cloneObj.message.replace(':name', this.name);
        }
        this.rules.push(cloneObj);
        return this;
    };
    FormRules.prototype.string = function (min, max, message) {
        if (message === void 0) { message = ''; }
        message = message || FormRules.formatMessageByLimit(min, max, '字符串', '长度');
        this.rules.push({
            type: FormRuleType_1.FormRuleType.string,
            min: min,
            max: max,
            message: message.replace(':name', this.name),
        });
        return this;
    };
    FormRules.prototype.bool = function (message) {
        if (message === void 0) { message = ':name必须是布尔值'; }
        this.rules.push({
            type: FormRuleType_1.FormRuleType.boolean,
            message: message.replace(':name', this.name),
        });
        return this;
    };
    FormRules.prototype.array = function (message) {
        if (message === void 0) { message = ':name必须是数组'; }
        this.rules.push({
            type: FormRuleType_1.FormRuleType.array,
            message: message.replace(':name', this.name),
        });
        return this;
    };
    FormRules.prototype.phone = function (message) {
        if (message === void 0) { message = '请输入正确的:name'; }
        this.rules.push({
            type: FormRuleType_1.FormRuleType.string,
            pattern: /^1[3-9]\d{9}$/,
            message: message.replace(':name', this.name),
        });
        return this;
    };
    FormRules.prototype.number = function (min, max, message) {
        if (message === void 0) { message = ''; }
        message = message || FormRules.formatMessageByLimit(min, max, '数字', '值');
        this.rules.push({
            type: FormRuleType_1.FormRuleType.number,
            transform: FormRules.transformNumber,
            min: min,
            max: max,
            message: message.replace(':name', this.name),
        });
        return this;
    };
    FormRules.prototype.integer = function (min, max, message) {
        if (message === void 0) { message = ''; }
        message = message || FormRules.formatMessageByLimit(min, max, '整数', '值');
        this.rules.push({
            type: FormRuleType_1.FormRuleType.integer,
            transform: FormRules.transformNumber,
            min: min,
            max: max,
            message: message.replace(':name', this.name),
        });
        return this;
    };
    FormRules.prototype.email = function (message) {
        if (message === void 0) { message = ':name必须是个邮箱号'; }
        this.rules.push({
            type: FormRuleType_1.FormRuleType.email,
            message: message.replace(':name', this.name),
        });
        return this;
    };
    FormRules.prototype.match = function (pattern, message) {
        if (message === void 0) { message = ':name不符合匹配标准'; }
        this.rules.push({
            type: FormRuleType_1.FormRuleType.string,
            pattern: pattern,
            message: message.replace(':name', this.name),
        });
        return this;
    };
    FormRules.prototype.url = function (message) {
        if (message === void 0) { message = ':name不符合url规则'; }
        this.rules.push({
            type: FormRuleType_1.FormRuleType.url,
            message: message.replace(':name', this.name),
        });
        return this;
    };
    FormRules.prototype.callback = function (func) {
        this.rules.push({
            validator: function (rule, value, callback) {
                var errors = func(value, rule.field);
                if (Array.isArray(errors)) {
                    callback(errors);
                }
                else if (errors === undefined || errors === null) {
                    callback([]);
                }
                else {
                    callback([errors]);
                }
            },
        });
        return this;
    };
    FormRules.prototype.identityCard = function (message) {
        if (message === void 0) { message = ':name不是有效的身份证'; }
        return this.match(/^(\d{18}|\d{17}[xX])$/, message);
    };
    FormRules.prototype.withoutWhiteSpace = function (message) {
        if (message === void 0) { message = ':name禁止包含空格'; }
        return this.match(/^[^\s]+$/, message);
    };
    FormRules.prototype.object = function (message) {
        if (message === void 0) { message = ':name必须是对象类型'; }
        this.rules.push({
            type: FormRuleType_1.FormRuleType.object,
            message: message.replace(':name', this.name),
        });
        return this;
    };
    FormRules.prototype.resetRule = function () {
        this.rules = [];
        return this;
    };
    FormRules.prototype.create = function () {
        return this.rules;
    };
    return FormRules;
}());
exports.FormRules = FormRules;
